import { localStorage } from '@muse-web/storages'

import { normalizeFlag } from './normalizeFlag'
import { STORAGE_KEYS } from './storageKeys'

export const readHqStoragePaywallSeen = (): boolean =>
    normalizeFlag(localStorage.get(STORAGE_KEYS.hqStoragePaywallSeen))

export const writeHqStoragePaywallSeen = (): void => {
    localStorage.set(STORAGE_KEYS.hqStoragePaywallSeen, 'true')
}
